import React, { Component } from 'react';
import '../../App.css';

import { Link } from 'react-router-dom'

class bannerPrincipal extends Component {
  constructor(props){
    super(props)
  }

  static defaultProps = {
    title:'',
    description:'',
    video:'',
    linkto:''
  }

  render() {
    return (
      <div className="banner-principal">
        <video controls={false} autoPlay muted loop>
            <source src={this.props.video} type="video/mp4"/>
            Your browser does not support the video tag.
        </video>
        <span>{this.props.title}</span>
        <p>{this.props.description}<br/><br/><br/>
        <Link to={"/ru/"+this.props.linkto}>узнать больше</Link>
        </p>
      </div>
    );
  }
}

export default bannerPrincipal;


// WEBPACK FOOTER //
// ./src/components/ru-home/banner-principal.js